var PageNotFound = function PageNotFound() {
  return /*#__PURE__*/React.createElement("div", {
    className: "page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-not-found"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-not-found__title"
  }, "404"), /*#__PURE__*/React.createElement("div", {
    className: "page-not-found__description"
  }, "Page not found, are you sure you are looking in the right place?"))));
};
export default PageNotFound;